import React, { createContext, useReducer } from 'react'

export const SET_DEF_PLUGIN_DATA = 'SET_DEF_PLUGIN_DATA'
export const UPDATE_DEF_PLUGIN_DATA = 'UPDATE_DEF_PLUGIN_DATA'
export const SET_SELECTED_IDS = 'SET_SELECTED_IDS'
export const SHOW_DEF_BULK_UPLOAD = 'SHOW_DEF_BULK_UPLOAD'
export const SHOW_DEF_UPLOAD_POPUP = 'SHOW_DEF_UPLOAD_POPUP'
export const SET_UPLOAD_GENERATE_FILE_STATUS = 'SET_UPLOAD_GENERATE_FILE_STATUS'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_DEF_PLUGIN_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_DEF_PLUGIN_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData }
    }
    case SET_SELECTED_IDS: {
      let tempSelectedIds = [...data.selectedIds]
      let item = payload.data
      tempSelectedIds.indexOf(item) === -1
        ? tempSelectedIds.push(item)
        : tempSelectedIds.splice(tempSelectedIds.indexOf(item), 1)
      return { ...data, selectedIds: tempSelectedIds }
    }
    case SHOW_DEF_BULK_UPLOAD: {
      return { ...data, show_bulk_upload: payload.data }
    }
    case SHOW_DEF_UPLOAD_POPUP: {
      return { ...data, show_upload_popup: payload.data }
    }
    case SET_UPLOAD_GENERATE_FILE_STATUS: {
      return {
        ...data,
        in_process_upload_file_harnesses:
          payload.data.in_process_upload_file_harnesses,
        in_process_generate_file_ids: payload.data.in_process_generate_file_ids,
        failed_due_to_error: payload.data.failed_due_to_error,
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedIds: [],
  show_bulk_upload: false,
  show_upload_popup: false,
  in_process_upload_file_harnesses: [],
  in_process_generate_file_ids: [],
  failed_due_to_error: [],
}

const DefPluginStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <DefPluginContext.Provider value={[state, dispatch]}>
      {children}
    </DefPluginContext.Provider>
  )
}

export const DefPluginContext = createContext(initialState)
export default DefPluginStore
